"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
const Configuration_1 = tslib_1.__importDefault(require("../Configuration"));
exports.isMessageAttachmentPurchaseTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "MessageAttachmentPurchaseTransactionDetails";
};
exports.isCustomRequestMessageDetails = (details) => details !== null && details.type === "custom_request";
class MessagesProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Message: () => `
        ... on Message {
          id
          senderId
          senderUser {
            ${this.getFragment("UserPublicData")}
          }
          text
          details
          threadId
          time
          link {
            ${this.getFragment("MessageLink")}
          }
          attachment {
            ${this.getFragment("MessageAttachment")}
          }
          ${Configuration_1.default.featurePaidMessageAttachments
                ? `
            attachmentPricePackageId
            attachmentAvailable
            attachmentPurchasers`
                : ""}
        }
      `,
            MessageAttachment: () => `
         ... on MessageAttachment {
             file {
              ${this.getFragment("File")}
            }
            publicAccess
         }
      `,
            TransactionDetails: () => `
        ... on MessageAttachmentPurchaseTransactionDetails {
          providerId
          consumerId
          subjectId
          message {
            ${this.getFragment("Message")}
          }
          opponent {
            ${this.getFragment("UserPublicData")}
          }
        }
      `,
        };
    }
    find({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("messagesFind", { data }, this.getPageableFragment("Message"));
        });
    }
    messageToUser({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("messageToUser", { data }, this.getFragment("Message"));
        });
    }
    sendExtendedMessages({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("sendExtendedMessages", { data }, this.getFragment("Message"));
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("deleteMessage", { id });
        });
    }
    createCustomRequest({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("createCustomRequest", { data }, this.getFragment("Message"));
        });
    }
    subscribeToThread(threadId, onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
        subscription($threadId: ID!) {
          messageReceived(threadId: $threadId) {
            ${this.getFragment("Message")}
          }
        }
      `,
            variables: { threadId },
        }, data => {
            onData(data.messageReceived);
        }, onError);
    }
    subscribeToAllThreads(onData, onError) {
        return this.subscribeToThread("0", onData, onError);
    }
}
exports.MessagesProvider = MessagesProvider;
//# sourceMappingURL=MessagesProvider.js.map